



































































































































































































































































































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { refsService } from '@/app/shared/refs.service';
import {
  CreditModel,
  DebitModel,
  PaymentInfoModel,
  ContractModel,
  CobillingtimModel,
} from '@/app/shared/models';
import { PaymentMethod } from '@/app/shared/enums';
import BadgeCreditCardThumb from '@/app/shared/components/badges/credit-card-thumb.vue';

@Component({ components: { BadgeCreditCardThumb } })
export default class FormPaymentComponent extends Vue {
  @Prop(Object) readonly data!: PaymentInfoModel;
  @Prop(Object) readonly card!: number;
  private listPaymentAvaiable: string[] = [];
  private listDebitInstitutions: string[] = [];
  private listBanks: any[] = [];

  private get refs() {
    return refsService;
  }
  private get rules() {
    return this.refs.static.rules;
  }
  private get contract(): ContractModel {
    return this.refs.modules.contract.contract;
  }
  private get email() {
    return this.refs.util.findEmail(
      this.refs.modules.contract.customer.Contacts
    );
  }
  private get getPaymentMethodAvaiable() {
    return this.refs.static.enumDescriptions.customEnum(
      this.refs.enums.PaymentMethod,
      this.listPaymentAvaiable
    );
  }

  private async mounted() {
    const contract = this.refs.modules.contract.contract;
    const billingMode = this.refs.enums.BillingMode[contract.BillingMode ?? -1];
    const frequency = this.refs.enums.PaymentFrequency[
      contract.Frequency ?? -1
    ];
    await this.refs.modules.contract
      .loadPaymentMethodAvaiableSettings({
        billingMode: billingMode,
        frequency: frequency,
      })
      .then((data) => {
        data.forEach((x) => {
          if (x.PaymentMethod == 'CoBillingTIM') {
            this.$set(
              this.data,
              'CobillingTIM',
              new CobillingtimModel(this.data)
            );
          }
          this.listPaymentAvaiable.push(x.PaymentMethod);
          if (
            x.FinancialInstitutionCode &&
            x.PaymentMethod ==
              this.refs.enums.PaymentMethod[
                this.refs.enums.PaymentMethod.Debit
              ].toString()
          ) {
            this.listDebitInstitutions.push(x.FinancialInstitutionCode);
          }
        });
      })
      .catch((err) => {
        this.$toast.error('ERROR ? ', err);
        return null;
      });

    this.setBanks();
  }

  private setBanks() {
    this.refs.static.banks.forEach((element) => {
      if (
        this.listDebitInstitutions.find((e) => e == element.value.toString())
      ) {
        this.listBanks.push(element);
      }
    });
  }

  @Watch('data.PaymentMethod')
  private onChangePaymentMethod(val: PaymentMethod) {
    this.$set(this.data, 'Credit', undefined);
    this.$set(this.data, 'Debit', undefined);
    this.$set(this.data, 'CobillingTIM', undefined);
    this.$set(this.data, 'BankSlip', undefined);
    this.$set(this.data, 'BrCode', undefined);
    if (
      this.refs.enums.PaymentMethod[val] ==
      this.refs.enums.PaymentMethod.Credit.toString()
    ) {
      this.$set(this.data, 'Credit', new CreditModel());
    } else if (
      this.refs.enums.PaymentMethod[val] ==
      this.refs.enums.PaymentMethod.Debit.toString()
    )
      this.$set(this.data, 'Debit', new DebitModel());
    else if (
      this.refs.enums.PaymentMethod[val] ==
      this.refs.enums.PaymentMethod.CoBillingTIM.toString()
    ) {
      this.$set(this.data, 'CobillingTIM', new CobillingtimModel(this.data));
    }
  }
}
